import authInterceptor from './auth-interceptor';
import axios from 'axios';
import state from 'store';
import { API_TIMEOUT, API_URL } from './variables';
import { AuthService, TOKEN_HEADER } from 'core/auth';
import { errorHandlerInterceptor } from './error-handler.interceptor';
import { FORBIDDEN } from 'http-status-codes';
import { selectOperationId } from 'store/modules/config';
import { v4 as uuid } from 'uuid';

const createAxiosInstance = ({
  baseURL,
  timeout = API_TIMEOUT,
}: {
  baseURL: string;
  timeout?: number;
}) => {
  const instanceAxios = axios.create({
    baseURL,
    timeout,
  });

  // request handler
  instanceAxios.interceptors.request.use(function (request) {
    const { token } = AuthService;

    // set required SessionId header
    request.headers.SessionId = uuid();
    request.headers.OperationId = selectOperationId(state.getState());

    // set token header in case there is no configured one
    if (token && !request.headers?.[`${TOKEN_HEADER}`]) {
      request.headers[`${TOKEN_HEADER}`] = token;
    }

    return request;
  });

  // error handler
  instanceAxios.interceptors.response.use(undefined, errorHandlerInterceptor);

  // refresh token interceptor
  instanceAxios.interceptors.response.use(
    undefined,
    authInterceptor(instanceAxios, (config) => AuthService.tokenRefresh(), {
      tokenHeaderName: TOKEN_HEADER,
      statusCodes: [FORBIDDEN],
    })
  );
  return instanceAxios;
};

const axiosInstance = createAxiosInstance({
  baseURL: API_URL,
});

export { axiosInstance, createAxiosInstance };
